import moment from 'moment'
import {
  getDocumentParamsList,
  getDocumentList,
  // delDocumentById,
  // addDocument,
  getDocumentDriverList,
  // editDocumentName,
  downloadDocumentAll,
  getDocumentLoadList } from '@/api/document-v2'
  import { editDocumentName, delDocumentName, paymentReportdelDocumentName } from '@/views/dispatchs/dispatch/api/new-index.js'
import { Message } from 'element-ui'

const documentAllColumns = [
  {
    fieldName: 'documentName',
    caption: 'Document Name',
    type: 'img-name',
    minWidth: '256px',
    params: {
      noClickCell: true,
    },
  },
  {
    fieldName: 'uploadedBy',
    caption: 'Uploaded by',
    type: 'img-name',
    minWidth: '144px',
    params: {
      noClickCell: true,
    },
  },
  {
    fieldName: 'uploadedDate',
    caption: 'Upload Date',
    minWidth: '200px',
    params: {
      noClickCell: true,
    },
  },
  {
    fieldName: 'type',
    caption: 'Document Type',
    minWidth: '200px',
    params: {
      noClickCell: true,
    },
  },
  {
    fieldName: 'documentTag',
    caption: 'Link Document To',
    minWidth: '200px',
    params: {
      noClickCell: true,
    },
  },
  {
    fieldName: 'isPrivate',
    caption: 'Access Level',
    minWidth: '198px',
    params: {
      noClickCell: true,
    },
  },
]
// const endTime = moment().hour(23).minutes(59).seconds(59).format('YYYY-MM-DD HH:mm:ss')
// const startTime = moment().hour(0).minutes(0).seconds(0).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss')


const state = {
  namespaced: true,
  state: {
    paramsList: {
      taskIdList: [],
      typeList: [],
      userList: []
    },
    totalElements: 0,
    documentAllList: [],
    documentAllFuzzyList: [],
    documentLoadList: [],
    documentLoadTotal: 0,
    documentDriverList: [],
    documentDriverTotal: 0,
    documentAllColumns: documentAllColumns,
    allStatusSearch: {
      page: 1,
      size: 20,
      blurry: null,
      uploadByIds: [],
      documentTypes: [],
      uploadDate: null
    },
    allTable: false,  // 是否加载
    loadTable: false,
    driverTable: false,
    loadError: false,
    allError: false,
    driverError: false,
    currentNode: {},
    pageName: 'All',
    is_blank:false,
  },
  mutations: {
    SET_DOCUMENT_ALL_LIST (state, data) {
      state.documentAllList = data.content || []
      state.totalElements = data.totalElements || 0
      state.is_blank = data.is_blank || false 
    },    
    SET_DOCUMENT_FUZZY_LIST (state, data) {
      state.documentAllFuzzyList = data.content || []
    },
    SET_DOCUMENT_LOAD_LIST (state, data) {
      state.documentLoadList = data.content || []
      state.documentLoadTotal = data.totalElements || 0
    },
    SET_DOCUMENT_DRIVER_LIST (state, data) {
      state.documentDriverList = data.content || []
      state.documentDriverTotal = data.totalElements || 0
    },
    SET_ALL_STATUS_SEARCH (state, search) {
      state.allStatusSearch = search
    },
    SET_ALL_TABLE (state, loading) {
      state.allTable = loading
    },
    SET_LOAD_TABLE (state, loading) {
      state.loadTable = loading
    },
    SET_DRIVER_TABLE (state, loading) {
      state.driverTable = loading
    },
    SET_CURRENT_NODE (state, data) {
      state.currentNode = data
    },
    SET_LOAD_ERROR (state, loading) {
      state.loadError = loading
    },
    SET_ALL_ERROR (state, loading) {
      state.allError = loading
    },
    SET_DRIVER_ERROR (state, loading) {
      state.driverError = loading
    },
    SET_PAGE_NAME (state, name) {
      state.pageName = name
    },
    SET_PARAMS_LIST (state, params) {
      state.paramsList.taskIdList = params.taskIdList || []
      state.paramsList.typeList = params.typeList || []
      state.paramsList.userList = params.userList || []
    },
    INIT_ALL_STATUS_SEARCH(state) {
      // const endTime = moment().hour(23).minutes(59).seconds(59).format('YYYY-MM-DD HH:mm:ss')
      // const startTime = moment().hour(0).minutes(0).seconds(0).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss')
      const obj = {
        page: 1,
        size: state.allStatusSearch.size,
        blurry: null,
        uploadByIds: [],
        documentTypes: [],
        uploadDate: null
      }
      // console.log(endTime)
      state.allStatusSearch = obj
    }
  },
  actions: {

    getDocumentDriverList({ commit, dispatch}, params) {
      getDocumentDriverList(params).then(res => {
        commit('SET_DRIVER_TABLE', false)
        const data = res.res.data || {}
        if (data.code == 200) {
          const obj = data.data || {}
          if (obj.content) {
            obj.content && obj.content.forEach(item => {
              item.documentResultList && item.documentResultList.forEach(it => {
                it.uploadedDate = moment(it.uploadedDate).format('MMM DD, YYYY, hh:mma')
                it.actualImgUrl = it.documentUrl
              })
            })
          }
          commit('SET_DOCUMENT_DRIVER_LIST', obj)
        }
        console.log(dispatch)
      }).catch(() => {
        commit('SET_DRIVER_TABLE', false)
        commit('SET_DRIVER_ERROR', true)
      })
    },
    getDocumentFuzzyDriverList({ commit, dispatch}, params) {
      getDocumentDriverList(params).then(res => {
        const data = res.res.data || {}
        if (data.code == 200) {
          const obj = data.data || {}
          if (obj.content) {
            obj.content && obj.content.forEach(item => {
              item.documentResultList && item.documentResultList.forEach(it => {
                it.uploadedDate = moment(it.uploadedDate).format('MMM DD, YYYY, hh:mma')
                it.actualImgUrl = it.documentUrl
              })
            })
          }
          commit('SET_DOCUMENT_FUZZY_LIST', obj)
        }
        console.log(dispatch)
      }).catch((err) => {
        console.log(err)
      })
    },

    getDocumenLoadList({ commit }, params) {
      getDocumentLoadList(params).then(res => {
        const data = res.res.data || {}
        commit('SET_LOAD_TABLE', false)
        if (data.code == 200) {
          const obj = data.data || {}
          if (obj.content) {
            obj.content && obj.content.forEach(item => {
              let st = moment(item.pickupTime).format('MMM DD')
              let ed = moment(item.deliveryTime).format('MMM DD')
              item.time = `${st}-${ed}`
              item.documentResultList && item.documentResultList.forEach(it => {
                it.uploadedDate = moment(it.uploadedDate).format('MMM DD, YYYY, hh:mma')
                it.actualImgUrl = it.documentUrl
              })
            })
          }
          commit('SET_DOCUMENT_LOAD_LIST', obj)
        } else {
          commit('SET_DOCUMENT_LOAD_LIST', {})
        }
      }).catch(() => {
        commit('SET_LOAD_TABLE', false)
        commit('SET_LOAD_ERROR', true)
      })
    },
    getDocumentFuzzyLoadList({ commit }, params) {
      getDocumentLoadList(params).then(res => {
        const data = res.res.data || {}
        if (data.code == 200) {
          const obj = data.data || {}
          if (obj.content) {
            obj.content && obj.content.forEach(item => {
              let st = moment(item.pickupTime).format('MMM DD')
              let ed = moment(item.deliveryTime).format('MMM DD')
              item.time = `${st}-${ed}`
              item.documentResultList && item.documentResultList.forEach(it => {
                it.uploadedDate = moment(it.uploadedDate).format('MMM DD, YYYY, hh:mma')
                it.actualImgUrl = it.documentUrl
              })
            })
          }
          commit('SET_DOCUMENT_FUZZY_LIST', obj)
        } else {
          commit('SET_DOCUMENT_FUZZY_LIST', {})
        }
      }).catch((err) => {
        console.log({err})
      })
    },
    getDocumenList({commit, dispatch}, params) {
      getDocumentList(params).then(res => {
        const data = res.res.data || {}
        if (data.code == 200) {
          const obj = data.data || {}
          if (obj.content) {
            obj.content && obj.content.forEach(item => {
              item.uploadedDate = moment(item.uploadedDate).format('MMM DD, YYYY, hh:mma')
              let documentName = {}
              documentName.root = 3
              documentName.docType =  item.fileType === 'pic' ? 'img': 'pdf'
              documentName.avatar = item.documentUrl
              documentName.documentUrl = item.documentUrl
              documentName.name = item.documentName
              item.documentName = documentName
              let uploadedBy = {}
              uploadedBy.root = 1
              uploadedBy.avatar = item.userIcon
              uploadedBy.name = item.uploadedBy
              uploadedBy.role = item.role
              uploadedBy.userId = item.userId
              item.uploadedBy = uploadedBy
              item.isPrivate = item.isPrivate ? 'Private' : 'Public'
              let tag = item.documentTagList.map(res => `${res.name}${res.tag ? `(${res.tag})` : ''}`)
              item.documentTag = tag.join(',')
              console.log(item.documentTag)
            })
            if (params.page > 0 && !obj.content.length) {
              dispatch('setAllStatusSearch', {
                name: 'page',
                value: params.page
              })
              dispatch('getDocumentAllList')
            } else {
              commit('SET_ALL_TABLE', false)
              commit('SET_DOCUMENT_ALL_LIST', obj)
            }
          } else {
            commit('SET_ALL_TABLE', false)
            commit('SET_DOCUMENT_ALL_LIST', {})
          }
        }
      }).catch(() => {
        commit('SET_ALL_TABLE', false)
        commit('SET_ALL_ERROR', true)
      })
    },
    getDocumentFuzzyList({commit}, params) {
      getDocumentList(params).then(res => {
        const data = res.res.data || {}
        if (data.code == 200) {
          const obj = data.data || {}
          if (obj.content) {
            obj.content && obj.content.forEach(item => {
              item.uploadedDate = moment(item.uploadedDate).format('MMM DD, YYYY, hh:mma')
              let documentName = {}
              documentName.root = 3
              documentName.docType =  item.fileType === 'pic' ? 'img': 'pdf'
              documentName.avatar = item.documentUrl
              documentName.documentUrl = item.documentUrl
              documentName.name = item.documentName
              item.documentName = documentName
              let uploadedBy = {}
              uploadedBy.root = 1
              uploadedBy.avatar = item.userIcon
              uploadedBy.name = item.uploadedBy
              uploadedBy.role = item.role
              uploadedBy.userId = item.userId
              item.uploadedBy = uploadedBy
              item.isPrivate = item.isPrivate ? 'Private' : 'Public'
              let tag = item.documentTagList.map(res => `${res.name}${res.tag ? `(${res.tag})` : ''}`)
              item.documentTag = tag.join(',')
              console.log(item.documentTag)
            })
              commit('SET_DOCUMENT_FUZZY_LIST', obj)
            }
          } else {
            commit('SET_DOCUMENT_FUZZY_LIST', {})
          }
      }).catch((err) => {
        console.log("Error getDocumentFuzzyList:",err)
      })
    },

    // 获取all列表
    getDocumentAllList ({ commit, state, dispatch }) {
      let params = JSON.parse(JSON.stringify(state.allStatusSearch))
      if (params.uploadDate && params.uploadDate.length && params.uploadDate[0].includes('-')) {
        params.uploadDate = params.uploadDate.map(item => {
          return moment(item).format('x')
        })
      }
      params.page > 0 ? params.page-- : ''
      commit('SET_LOAD_ERROR', false)
      commit('SET_ALL_ERROR', false)
      commit('SET_DRIVER_ERROR', false)
      switch (state.pageName) {
        case 'All':
          dispatch('getDocumenList', params)
          break
        case 'Loads':
          dispatch('getDocumenLoadList', params)
          break
        case 'Drivers':
          dispatch('getDocumentDriverList', params)
          break
      }
    },    
    getDocumentAllFuzzyList ({ state, dispatch }) {
      let params = { page: 0,
        size: 100000,
        blurry: null,
        uploadByIds: [],
        documentTypes: [],
        uploadDate: null}
      if (params.uploadDate && params.uploadDate.length && params.uploadDate[0].includes('-')) {
        params.uploadDate = params.uploadDate.map(item => {
          return moment(item).format('x')
        })
      }
      switch (state.pageName) {
        case 'All':
          dispatch('getDocumentFuzzyList', params)
          break
        case 'Loads':
          dispatch('getDocumentFuzzyLoadList', params)
          break
        case 'Drivers':
          dispatch('getDocumentFuzzyDriverList', params)
          break
      }
    },
    getDocumentParamsList({ commit }) {
      getDocumentParamsList().then(res => {
        const data = res.res.data || {}
        if (data.code == 200 && data.message == 'success') {
          const params = data.data || {}
          params.typeList && params.typeList.forEach((item, index) => {
            let obj = {}
            obj.label = String(item)
            obj.value = String(item)
            params.typeList[index] = obj
          })
          params.taskIdList && params.taskIdList.forEach((item, index) => {
            let obj = {}
            obj.label = item.newLoadId
            obj.value = item.loadId
            params.taskIdList[index] = obj
          })

          commit('SET_PARAMS_LIST', params)
        }
      })
    },
    delDocument ({dispatch, state}) {
      return new Promise((reslove, reject) => {
        console.log(state,'gjakasdljg-gadgas')
        let fileId = state.currentNode.documentId
        if(state.currentNode.scope === 'Payment-Report') {
          paymentReportdelDocumentName([fileId]).then(res => {
            dispatch('setLoadTable', true)
            dispatch('getDocumentAllList')
            reslove(res)
          }).catch(() => {
            reject()
          })
          return
        }
        delDocumentName(fileId).then(res => {
          dispatch('setLoadTable', true)
          dispatch('getDocumentAllList')
          reslove(res)
        }, () => {
          reject()
        }).catch(() => {
          reject()
        })
      })
    },
    editDocument ({ dispatch}, data) {
      console.log(data)
      return new Promise((resole, reject) => {
        editDocumentName(data).then(res => {
          dispatch('setLoadTable', true)
          dispatch('getDocumentAllList')
          resole(res)
        },() => {
          reject()
        } )
      })
    },
    addDocumentAfter({ dispatch, commit }) {
      // return new Promise((resolve, reject) =>{
        // addDocument(data).then(res => {
          // const data = res.res.data || {}
          // if (data.code == 200) {
            commit('INIT_ALL_STATUS_SEARCH')
            dispatch('setLoadTable', true)
            dispatch('getDocumentAllList')
            // resolve(res)
          // } else {
            // reject(res)
          // }
        // }).catch((res) => {
          // reject(res)
        // })
      // })
    },
    // 修改单个搜索条件
    setAllStatusSearch({ commit, state }, data) {
      if (data) {
        const field = data.name
        const obj = Object.assign({}, state.allStatusSearch)
        obj[field] = data.value
        commit('SET_ALL_STATUS_SEARCH', obj)
      }
    },
    initAllStatusSearch({ commit, dispatch}, data) {
      if (data) {
        commit('INIT_ALL_STATUS_SEARCH')
      } else {
        commit('INIT_ALL_STATUS_SEARCH')
        dispatch('setLoadTable', true)
        dispatch('getDocumentAllList')
      }
    },
    setLoadTable({ commit }, truth) {
      commit('SET_LOAD_TABLE', truth)
      commit('SET_DRIVER_TABLE', truth)
      commit('SET_ALL_TABLE', truth)
    },
    setCurrentNode({ commit }, data = {}) {
      commit('SET_CURRENT_NODE', data)
    },
    setPageName({ commit }, name) {
      commit('SET_PAGE_NAME',  name)
    },
    downAllFileInState(state, data) {
      // const message = Message.info({
      //   duration: 0,
      //   message: 'Preparing download, please wait for a moment.'
      // })
      return downloadDocumentAll(data).then(res => {
        // message.close()
        if (res?.res?.data.code === 200) {
          const url = res.res.data.data
          const a = document.createElement("a")
          a.setAttribute('href', url)
          // a.setAttribute('target', '_blank')
          document.body.appendChild(a) // 修复firefox中无法触发click
          a.click()
          document.body.removeChild(a)
        } else {
          Message.error(res.res.data.message)
        }
      },  (error) => {
        // message.close()
        if (error?.error?.message) {
          Message.error(error.error.message)
        }
      })
    }
  },
  getters: {
    documentAllList: state => state.documentAllList,
    documentAllFuzzyList: state => state.documentAllFuzzyList,
    documentAllColumns: state => state.documentAllColumns,
    totalElements: state => state.totalElements,
    allStatusSearch: state => state.allStatusSearch,
    paramsList: state => state.paramsList,
    loadTable: state => state.loadTable,
    driverTable: state => state.driverTable,
    documentLoadList: state => state.documentLoadList,
    loadError: state => state.loadError,
    currentNode: state => state.currentNode,
    pageName: state => state.pageName,
    documentLoadTotal: state => state.documentLoadTotal,
    documentDriverList: state => state.documentDriverList,
    documentDriverTotal: state => state.documentDriverTotal,
    allTable: state => state.allTable,
    is_blank: state => state.is_blank,
    
  }
}

export default state
